var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('h4',{staticClass:"mb-0 text-center"},[_c('strong',[_vm._v(_vm._s(_vm._f("snakeToTitleCase")(_vm.tenant.name)))])]),_vm._v(" "),_c('div',{staticClass:"small text-muted text-center"},[_vm._v("your tenant name")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab87a93e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tenant/components/TenantInfo.vue
// module id = null
// module chunks = 